module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Slider.js"));
	}, "Slider");
}